module.exports = __webpack_public_path__ + "img/spotlight.75fdc03b.jpg";